<template>
  <div v-if="display" id="image-uploader-modal" class="modal"
    aria-hidden="true"
    aria-labelledby="signInModalToggle"
    tabindex="-1">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <span>{{$t("uploader.title")}}</span>
          <button type="button"
            class="btn-close"
            @click="close"
            data-bs-dismiss="modal"
            aria-label="Close">
          </button>
        </div>
        <div class="modal-body">
          <div class="col-md-12">
            <div
              @dragenter="OnDragEnter"
              @dragleave="OnDragLeave"
              @dragover.prevent
              @drop="onDrop"
              :class="{dragging: isDragging}">
              <div class="uploader" v-if="upload">
                <div class="row">
                  <div class="col-sm-12">
                    <p>{{$t("uploader.drag")}}</p>
                    <p>O</p>
                    <div class="file-input">
                      <label for="file">{{$t("uploader.choose")}}</label>
                      <input type="file" id="file" @change="onInputChange" multiple />
                    </div>
                  </div>
                </div>
              </div>
                <file-pond
                  name="user_media[file]"
                  class="filepond-media"
                  ref="pond"
                  multiple="true"
                  v-on:init="handleFilePondInit"/>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import UploaderMixin from "../../mixins/UploaderMixin"
import vueFilePond, { setOptions } from 'vue-filepond'

import FilePondPluginFileEncode from 'filepond-plugin-file-encode'
import FilePondPluginFileValidateType from 'filepond-plugin-file-validate-type'
import FilePondPluginImageExifOrientation from 'filepond-plugin-image-exif-orientation'
import FilePondPluginImagePreview from 'filepond-plugin-image-preview'
import FilePondPluginImageCrop from 'filepond-plugin-image-crop'
import FilePondPluginImageResize from 'filepond-plugin-image-resize'
import FilePondPluginImageTransform from 'filepond-plugin-image-transform'
import FilePondPluginFileRename from 'filepond-plugin-file-rename'
import "filepond/dist/filepond.min.css"
import 'filepond-plugin-image-preview/dist/filepond-plugin-image-preview.css';

const FilePond = vueFilePond(
  FilePondPluginFileEncode,
  FilePondPluginFileValidateType,
  FilePondPluginImageExifOrientation,
  FilePondPluginImagePreview,
  FilePondPluginImageCrop,
  FilePondPluginImageResize,
  FilePondPluginImageTransform,
  FilePondPluginFileRename
)

export default {
  name: "ModalUploader",
  mixins: [
    UploaderMixin
  ],
  props:  {
    display: {
      type: Boolean,
      default: false
    },
    userId: {
      type: Number,
      default: null
    },
  },
  data() {
    return {
      modal: null,
      upload: true,
      maxMbSize: 300
    }
  },
  components: {
    FilePond
  },
  mounted() {
    this.renderFilepond();
  },
  watch: {
    display(val, oldVal) {
      if(val) {
        this.$nextTick(() => {
          this.modal = new bootstrap.Modal(document.getElementById('image-uploader-modal'), {})
          this.modal.show()
        })
      } else {
        this.modal.hide()
      }
    }
  },
  methods:  {
    handleFilePondInit: function () {
    },
    getMbSize(size) {
      return (size / (1024*1024)).toFixed(2);
    },
    onInputChange(e) {
      this.inputs = e.target.files;
      this.addFile();
    },
    onDrop(e) {
      e.preventDefault();
      e.stopPropagation();
      this.isDragging = false;
      this.inputs = e.dataTransfer.files;
      this.addFile();
    },
    addFile() {
      const pond = document.querySelector('.filepond--root');
      this.upload = false;

      if(this.index < this.inputs.length) {
        var file = this.inputs[this.index], _this = this;

        if(file.type.match('video.*')) {
          this.addVideo(file, this.index, function() {
            _this.index++;
            _this.addFile();
          });
        } else if(file.type.match('image.*')) {
          this.addImage(file, this.index, function() {
            _this.index++;
            _this.addFile();
          });
        }
      }
      pond.addEventListener('FilePond:onprocessfiles', e => {});
    },
    addImage(file, index, complete) {
      const img = new Image(), reader = new FileReader(), _this = this;

      this.files.push({
        name: file.name,
        size: file.size,
        timestamp: '',
        dimensions: {}
      });

      reader.onload = (e) => {
        img.src = e.target.result;

        img.onload = function() {
          _this.files[index].dimensions = { w: img.width, h: img.height };

          _this.resizePhoto(_this.files[index], e.target.result).then(function(newImg) {
            _this.files[index].timestamp = moment(file.lastModified).format("YYYYMMDD_hhmmss") + index;

            var blob = _this.base64ToBlob(newImg);
            blob.name = _this.files[index].timestamp;
            blob.original_filename = file.name;

            _this.$refs.pond.addFile(blob, {index: index});
            complete();
          });
        };
      };
      reader.readAsDataURL(file);
    },
    addVideo(file, index, complete) {
      var size = this.getMbSize(file.size);
      if(size > this.maxMbSize) {
        alertify.error(`El video: ${file.name}, excede el tamaño maximo de ${this.maxMbSize} MB`);
      } else {
        const reader = new FileReader(), _this = this;
        this.files.push({
          name: file.name,
          size: file.size,
          timestamp: moment(file.lastModified).format("YYYYMMDD_hhmmss") + index,
          dimensions: {}
        });

        reader.onload = () => {
          var blob = _this.videoBase64ToBlob(reader.result);
          blob.name = _this.files[index].timestamp;
          blob.original_filename = file.name;

          _this.$refs.pond.addFile(blob, {index: index});
          complete();
        };
        reader.readAsDataURL(file);
      }
    },
    renderFilepond() {
      const _this = this

      setOptions({
        labelIdle: '',
        credits: false,
        allowDrop: false,
        allowPaste: false,
        allowRemove: false,
        allowMultiple: true,
        allowBrowse: false,
        instantUpload: true,
        allowReplace: false,
        maxParallelUploads: 3,
        allowImagePreview: true,
        imagePreviewHeight: 120,
        imagePreviewMaxHeight: 120,
        server: {
          url:    '/',
          process:(fieldName, file, metadata, load, error, progress, abort, transfer, options) => {
            const timestamp = file.name.replace('.jpg', ''),
                  record = _this.getFile(timestamp),
                formData = new FormData();
                            
            formData.append('timestamp',  timestamp);
            formData.append('user_id',  _this.userId);
            formData.append(fieldName, file, file.name);
            formData.append('event_id',  _this.event);
            formData.append('original_name',  record.name);
            formData.append('event_category_id',  _this.category.id);

            const request = new XMLHttpRequest();
            request.open('POST', `${CHUSPIC_PHOTOS_API}/v1/media`);
            request.setRequestHeader('Tenant', CURRENT_TENANT);

            request.upload.onprogress = (e) => {
              progress(e.lengthComputable, e.loaded, e.total)
            };

            request.onload = function() {
              if(request.status >= 200 && request.status < 300) {
                load(request.responseText)
              } else {
                error('oh no')
              }
            };

            request.send(formData);
              return {
                abort: () => {
                  request.abort()
                  abort()
                }
              };
            }
          },
        onprocessfiles: () => {
          location.reload();
        },
        fileRenameFunction: (file) => {
          return file.name;
        },
        beforeAddFile: (fileItem) => new Promise(resolve => {
          return resolve(fileItem);
        })
      })
    },
    close() {
      this.$emit('update:display', false)
    }
  },
  computed: {
  }
}
</script>

<style lang="scss">
  $uploader-color: #87898C;
  $uploader-bg-color: #f1f0ef;

  #image-uploader-modal {
    .modal-dialog {
      width: 80% !important;
      max-width: 80% !important;
      margin: auto;
      top: 100px;

      .modal-header {
        border-bottom: 1px solid gray !important;
      }

      .modal-content {
        min-height: 300px;
        overflow-y: auto;
      }
    }

    .filepond-media { }
  }

  .uploader {
    background-color: $uploader-bg-color;
    border: 2px dashed $uploader-color;
    color: $uploader-color;
    width: 100%;
    padding: 10px;
    text-align: center;
    border-radius: 10px;
    font-size: 18px;
    position: relative;

    p { margin: 0;}

    &.dragging {
      background: #fff;
      color: $uploader-color;
      border: 3px dashed $uploader-color;
      .file-input label {
        background: $uploader-color;
        color: #fff;
      }
    }
    i { font-size: 75px; }
    .file-input {
      position: relative;
      margin: auto;
      width: 250px;
      height: 32px;

      label, input {
        background-color: $uploader-bg-color;
        color: $uploader-color;
        width: 100%;
        position: absolute;
        left: 0;
        top: 0;
        border-radius: 4px;
        cursor: pointer;
        font-weight: bold;
        font-size: 20px;
      }
      input {
        opacity: 0;
        z-index: -2;
      }
    }

    .upload-control {
      position: absolute;
      width: 100%;
      background: #fff;
      top: 0;
      left: 0;
      border-top-left-radius: 7px;
      border-top-right-radius: 7px;
      padding: 10px;
      padding-bottom: 4px;
      text-align: right;
      border-bottom: 2px dashed $uploader-color;

      button, label {
        background: $uploader-color;
        border: 2px solid $uploader-color;
        border-radius: 3px;
        color: #fff;
        font-size: 15px;
        cursor: pointer;
        font-weight: normal;
      }
      label {
        padding: 0 5px;
        margin-right: 10px;
      }
    }

    .images-list {
      display: flex;
      flex-wrap: wrap;
      margin-top: 50px;
      color: #000;
      font-size: 12px;
      text-align: left;
      max-height: 450px;
      overflow-y: auto;

      .img-wrapper {
        background: #fff;
        box-shadow: 2px 2px 3px gray;
        padding: 10px 0;
        margin-bottom: 5px;
        margin-right: -10px;
        max-height: 78px;
        img {
          max-height: 53px !important;
          object-fit: contain;
          width: 100%;
        }
        .size {
          font-size: 10px;
          color: gray;
        }
      }
    }
  }

  .sm-loader {
    position: absolute;
    top: 0;
    bottom: 0;
    width: 100%;
    background-color: rgba(255, 255, 255, 0.6);
    z-index: 9999;

    div {
      border: 3px solid transparent;
      border-top: 3px solid #ff8330;
      border-radius: 200px;
      -webkit-animation: spin 2s infinite linear;
    }
    .first {
      width: 40px;
      height: 40px;
      position: absolute;
      top: 70%;
      left: 58%;
      margin-left: -40px;
      margin-top: -40px;
    }
    .second {
       width: 25px;
       height: 25px;
       margin: 5px;
    }
    .third {
       width: 10px;
       height: 10px;
       margin: 5px;
    }
    @-webkit-keyframes spin {
      0% {-webkit-transform: rotateZ(0deg);}
      100% {-webkit-transform: rotateZ(360deg);}
    }
  }

  /* filepond */
  $filepond-height: 0;

  .filepond--root {
    min-height: $filepond-height !important;
  }

  .filepond--root .filepond--drop-label, .filepond--label-action {
    min-height: $filepond-height !important;
  }

  .filepond--drop-label.filepond--drop-label label {
    font-size: 18px;
  }

  .filepond--panel-root {
    background: #FFF !important;
  }

  .filepond--image-preview {
    background: #bfbfbf !important;
  }

  .filepond--item {
    width: calc(50% - .5em);
  }

  @media (min-width: 30em) {
    .filepond--item {
      width: calc(50% - .5em);
    }
  }

  @media (min-width: 50em) {
    .filepond--item {
      width: calc(25% - .5em);
    }
  }
</style>
